module.exports = __webpack_public_path__ + "Icono_Pedidos_512px.png";